import { IntersectionFade } from "../components/IntersectionFade";

function CheckIcon() {
  return (
    <svg className="pricing-feature-check" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}

const COMMUNITY_FEATURES = [
  "Unlimited screens",
  "All platform players (Web, Electron, Tauri, Android TV, Pi)",
  "Full KSP push sync protocol",
  "Offline-first content cache",
  "Proof-of-play analytics",
  "Multi-zone JSON layouts",
  "Dayparting & scheduling",
  "Self-hosted on your own infrastructure",
  "Community support (GitHub, Discord)",
];

const PRO_FEATURES = [
  "Everything in Community",
  "Managed cloud CMS (Cloudflare + Neon)",
  "Advanced analytics dashboard",
  "SSO / SAML integration",
  "Priority support (email, 48 h SLA)",
  "Automatic player updates",
  "Custom branding & domain",
  "Multi-tenant organisation management",
  "Up to 10 workspaces",
];

const ENTERPRISE_FEATURES = [
  "Everything in Pro",
  "Dedicated Cloudflare zone",
  "99.9% uptime SLA",
  "QuantumOS X3 plugin integration",
  "Unlimited workspaces & tenants",
  "Custom player shells & OEM branding",
  "On-premises deployment option",
  "Dedicated solutions engineer",
  "Enterprise support (phone, 4 h SLA)",
];

export function Pricing() {
  return (
    <section className="section" id="pricing" aria-labelledby="pricing-heading">
      <div className="container">
        <IntersectionFade>
          <div className="section-header">
            <span className="eyebrow">Pricing</span>
            <h2 className="h2" id="pricing-heading">
              Simple, transparent{" "}
              <span className="grad-text">pricing</span>
            </h2>
            <p className="lead">
              Start free and self-host with no limits. Upgrade to cloud-managed or enterprise when you&apos;re ready.
            </p>
          </div>
        </IntersectionFade>

        <div className="pricing-grid">
          {/* Community */}
          <IntersectionFade delay={0}>
            <div className="pricing-card">
              <div className="pricing-tier">Community</div>
              <div className="pricing-price">
                <span className="pricing-price-num">$0</span>
                <span className="pricing-price-unit">/ forever</span>
              </div>
              <p className="pricing-tagline">
                Full-featured, self-hosted. No screen limits, no expiry, no catch.
              </p>
              <div className="pricing-divider" />
              <ul className="pricing-features" aria-label="Community plan features">
                {COMMUNITY_FEATURES.map((f) => (
                  <li key={f} className="pricing-feature">
                    <CheckIcon />
                    {f}
                  </li>
                ))}
              </ul>
              <a href="https://github.com/kynetra" className="pricing-cta" aria-label="Get started with Community plan">
                Self-host for free
              </a>
            </div>
          </IntersectionFade>

          {/* Pro */}
          <IntersectionFade delay={80}>
            <div className="pricing-card featured" aria-label="Most popular plan">
              <div className="pricing-badge" aria-label="Most popular">Most popular</div>
              <div className="pricing-tier">Pro</div>
              <div className="pricing-price">
                <span className="pricing-price-num">$4</span>
                <span className="pricing-price-unit">/ screen / mo</span>
              </div>
              <p className="pricing-tagline">
                Cloud-managed CMS, analytics, and SSO. We run the infrastructure.
              </p>
              <div className="pricing-divider" />
              <ul className="pricing-features" aria-label="Pro plan features">
                {PRO_FEATURES.map((f) => (
                  <li key={f} className="pricing-feature">
                    <CheckIcon />
                    {f}
                  </li>
                ))}
              </ul>
              <button type="button" className="pricing-cta featured" aria-label="Start Pro plan">
                Start 14-day trial
              </button>
            </div>
          </IntersectionFade>

          {/* Enterprise */}
          <IntersectionFade delay={160}>
            <div className="pricing-card">
              <div className="pricing-tier">Enterprise</div>
              <div className="pricing-price">
                <span className="pricing-price-num" style={{ fontSize: "1.8rem" }}>Custom</span>
              </div>
              <p className="pricing-tagline">
                Multi-tenant, dedicated infrastructure, SLA, and QuantumOS X3 integration.
              </p>
              <div className="pricing-divider" />
              <ul className="pricing-features" aria-label="Enterprise plan features">
                {ENTERPRISE_FEATURES.map((f) => (
                  <li key={f} className="pricing-feature">
                    <CheckIcon />
                    {f}
                  </li>
                ))}
              </ul>
              <button type="button" className="pricing-cta" aria-label="Contact sales for Enterprise plan">
                Contact sales
              </button>
            </div>
          </IntersectionFade>
        </div>

        <IntersectionFade delay={200}>
          <p className="text-center text-muted text-sm mt-32">
            All plans include proof-of-play analytics and access to all player platforms.
            Pro and Enterprise are billed annually. Volume discounts available.
          </p>
        </IntersectionFade>
      </div>
    </section>
  );
}
